/* Envuelve el texto de cada botón en <span class="btn-t"> para que la raya dorada mida lo mismo que el texto.
   Vuelve a envolverlo si otro script cambia el texto (p. ej. "Añadir a la cesta" ↔ "Agotado"). */
(function () {
  function envolver(b) {
    [].slice.call(b.childNodes).forEach(function (n) {
      if (n.nodeType === 3 && n.nodeValue.trim()) {
        var s = document.createElement('span'); s.className = 'btn-t';
        s.textContent = n.nodeValue.trim(); b.replaceChild(s, n);
      }
    });
  }
  function todo(raiz) { [].slice.call((raiz || document).querySelectorAll('.btn')).forEach(envolver); }
  todo();
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      var el = m.target.nodeType === 3 ? m.target.parentNode : m.target;
      if (!el || !el.closest) return;
      var b = el.closest('.btn');
      if (b) envolver(b); else if (m.addedNodes.length) todo(el);
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();

/* Logo en la portada: si ya estás en la portada, tocar el logo sube deslizándose hasta arriba en vez de recargar.
   En cualquier otra página el logo sigue llevando a la portada. */
(function () {
  var raiz = (window.KS && KS.root) || '/';
  function enPortada() { var p = location.pathname.replace(/\/+$/, '') || '/'; var r = raiz.replace(/\/+$/, '') || '/'; return p === r; }
  function subir() {
    var y0 = window.scrollY, t0 = null, dur = Math.min(900, 300 + y0 / 4);
    if (y0 <= 0) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo(0, 0); return; }
    function paso(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / dur), e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
      window.scrollTo(0, Math.round(y0 * (1 - e)));
      if (k < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.hdr-logo');
    if (!a || !enPortada() || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault(); subir();
  });
})();

/* "Ordenar por": el desplegable mide lo mismo que la opción elegida, así el punto dorado queda justo al final
   del texto (como en el menú) y se entiende que se puede tocar para cambiar. */
(function () {
  var cv = document.createElement('canvas').getContext('2d');
  /* Shopify manda esta opción en inglés aunque la tienda esté en español */
  [].slice.call(document.querySelectorAll('.sort select option[value="most-relevant"]')).forEach(function (o) { o.text = 'Más relevantes'; });
  function ajustar(s) {
    var c = getComputedStyle(s), o = s.options[s.selectedIndex];
    if (!o) return;
    var t = c.textTransform === 'uppercase' ? o.text.toUpperCase() : o.text;
    cv.font = c.fontWeight + ' ' + c.fontSize + ' ' + c.fontFamily;
    var ls = parseFloat(c.letterSpacing) || 0;
    s.style.width = Math.ceil(cv.measureText(t).width + ls * t.length + parseFloat(c.paddingLeft) + parseFloat(c.paddingRight) + 2) + 'px';
  }
  function todos() { [].slice.call(document.querySelectorAll('.sort select')).forEach(ajustar); }
  document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('.sort select')) ajustar(e.target); });
  todos();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(todos);
  window.addEventListener('resize', todos);
})();

/* Todo lo que lleva punto dorado se despliega al pasar el ratón, como Mujer/Hombre en el menú (solo con ratón;
   en el móvil se sigue abriendo al tocar). Filtros Precio/Color/Talla y "Ordenar por". */
(function () {
  var mq = window.matchMedia('(hover:hover) and (min-width:990px)');
  var abiertos = [];
  function cerrarOtros(el) { abiertos.forEach(function (o) { if (o !== el) o.cerrar(true); }); }
  function hover(el, abrir, cerrar, ocupado) {
    var t = null, obj = { cerrar: function (ya) { clearTimeout(t); if (ya) cerrar(); else t = setTimeout(function () { if (!ocupado || !ocupado()) cerrar(); }, 180); } };
    abiertos.push(obj);
    el.addEventListener('mouseenter', function () { if (!mq.matches) return; clearTimeout(t); cerrarOtros(obj); abrir(); });
    el.addEventListener('mouseleave', function () { if (!mq.matches) return; obj.cerrar(false); });
  }
  /* Filtros (<details class="facet">) */
  [].slice.call(document.querySelectorAll('details.facet')).forEach(function (d) {
    hover(d, function () { d.open = true; }, function () { d.open = false; },
      function () { var a = document.activeElement; return a && d.contains(a) && a.tagName === 'INPUT' && a.type === 'number'; });
  });
  /* "Ordenar por": lista propia con el mismo aspecto que los filtros; el <select> real sigue enviando el orden */
  [].slice.call(document.querySelectorAll('.sort select')).forEach(function (s) {
    var lab = s.closest('.sort'); if (!lab || lab.querySelector('.sort-dd')) return;
    var dd = document.createElement('div'); dd.className = 'sort-dd';
    var b = document.createElement('button'); b.type = 'button'; b.className = 'sort-btn'; b.setAttribute('aria-haspopup', 'listbox');
    var ul = document.createElement('ul'); ul.className = 'sort-pop'; ul.setAttribute('role', 'listbox'); ul.hidden = true;
    function pintar() {
      b.textContent = s.options[s.selectedIndex] ? s.options[s.selectedIndex].text : '';
      ul.innerHTML = '';
      [].slice.call(s.options).forEach(function (o, i) {
        var li = document.createElement('li'), x = document.createElement('button');
        x.type = 'button'; x.textContent = o.text; x.setAttribute('role', 'option');
        if (i === s.selectedIndex) { x.className = 'on'; x.setAttribute('aria-selected', 'true'); }
        x.addEventListener('click', function () { ul.hidden = true; if (s.selectedIndex === i) return; s.selectedIndex = i; pintar(); s.dispatchEvent(new Event('change', { bubbles: true })); });
        li.appendChild(x); ul.appendChild(li);
      });
    }
    pintar();
    dd.appendChild(b); dd.appendChild(ul);
    s.parentNode.insertBefore(dd, s.nextSibling);
    lab.classList.add('sort-propio');
    b.addEventListener('click', function (e) { e.preventDefault(); ul.hidden = !ul.hidden; });
    document.addEventListener('click', function (e) { if (!lab.contains(e.target)) ul.hidden = true; });
    hover(lab, function () { ul.hidden = false; }, function () { ul.hidden = true; });
  });
})();
